<template>
  <div :class="{'main-box-data-open': isDataOpen, 'main-box-data-close': !isDataOpen}" v-if="!$route.query.view" @blur="changeIndex = -1">
    <div class="recruit-header" v-if="(filtered['filters'].length > 0) || (sortAsc || sortDesc && isFilter(sortIdx, 'sort'))">
      <!-- フィルター条件タグ -->
      <div style="font-weight: 600; margin-left: 16px;" v-if="filtered['filters'].length > 0"><span class="mdi mdi-filter" style="margin-right: 8px;"></span>Filter</div>
      <b-tag style="margin-left: 8px;" v-for="(f, i) in filtered['filters']" :key="i">
        {{f.name}}: 
        <!-- 履歴指定 -->
        <template v-if="isFilter(f.type, 'history_select')">{{f.data}}</template>
        <!-- テキスト指定 -->
        <template v-if="isFilter(f.type, 'text')">{{f.data === '-' ? '-' : f.data}}</template>
        <!-- セグメント -->
        <template v-if="isFilter(f.type, 'seg_select')">{{f.data === '-' ? '-' : f.data}}</template>
        <!-- スカウト設定 -->
        <template v-if="isFilter(f.type, 'set_select')">{{f.data ? '設定済' : '未設定'}}</template>
        <!-- 次回スカウト、過去スカウト -->
        <template v-if="isFilter(f.type, 'app_select')">{{f.data === '-' ? '-' : f.data}}</template>
        <!-- 直近訪問日 -->
        <template v-if="isFilter(f.type, 'date')">{{f.fromDate ? f.fromDate.toLocaleDateString() : '下限なし'}} - {{f.toDate ? f.toDate.toLocaleDateString() : '上限なし'}}</template>
        <!-- ロボとの会話 -->
        <template v-if="isFilter(f.type, 'exist_select')">{{f.data ? 'あり' : 'なし'}}</template>
        <!-- 数値指定 -->
        <template v-if="isFilter(f.type, 'number')">{{f.filterMin >= 0 ? f.filterMin : '下限なし'}} - {{f.filterMax >= 0 ? f.filterMax : '上限なし'}}</template>
        <!-- 該当フィルタ削除 -->
        <span @click="deleteFilter(i)" class="mdi mdi-close" style="margin-left: 4px; cursor: pointer;"></span>
      </b-tag>
      <!-- フィルタ条件一括削除タグ -->
      <b-tag style="margin-left: 8px;" v-if="filtered['filters'].length > 1">
        <template>フィルターを全て解除</template>
        <span @click="deleteFilterAll()" class="mdi mdi-close" style="margin-left: 4px; cursor: pointer;"></span>
      </b-tag>
      <!-- ソート条件タグ -->
      <div style="font-weight: 600; margin-left: 16px;" v-if="sortAsc || sortDesc && isFilter(sortIdx, 'sort')"><span class="mdi mdi-sort" style="margin-right: 8px;"></span>Sort</div>
      <b-tag style="margin-left: 8px;" v-if="sortAsc || sortDesc && isFilter(sortIdx, 'sort')">
        <template v-if="sortAsc && !sortDesc">{{headers[sortIdx]}}: 昇順</template>
        <template v-else-if="!sortAsc && sortDesc">{{headers[sortIdx]}}: 降順</template>
        <!-- ソート解除 -->
        <span @click="idxSort = -1;listSort(idxSort, false, false)" class="mdi mdi-close" style="margin-left: 4px; cursor: pointer;"></span>
      </b-tag>
    </div>
    <div class="recruit-box" v-if="scoutSeekers.length > 0 && !isScoutSeekerLoading">
      <table class="recruit-table disp-scroll" style="overflow: scroll; will-change: transform;">
        <tr style="position: relative;">
          <th style="min-width: 50px;"><b-checkbox v-model="isAllSelected" @input="allSelect()" style="margin-left: 8px; margin-top: 4px;"></b-checkbox></th>
          <th v-for="(t, i) in headers" :key="i">
            <p style="margin-left: 40px; margin-right: 40px;">{{t}}</p>
            <!-- フィルター設定 -->
            <button class="filter-button"
              @click="idxFilter = i; idxSort = -1"
              v-if="isFilter(i, 'filter') && !isFilterSet(i)">
              <span class="mdi mdi-filter"></span>
            </button>
            <div style="position: absolute; width: auto; padding: 8px; top: 45px; background: #f8f8f8; color: #2c3e50; border: solid thin #ccc;"
              v-if="i === idxFilter">
              <h2 style="padding: 8px; font-weight: 600;">{{t}}</h2>
              <!-- 訪問者(1)、タグ(2)、最長滞在ページ(11)、アクセス元(11) -->
              <input class="input is-small" style="width: 95%;" placeholder="フィルタを入力" v-model="filterWord" v-if="isFilter(i, 'text')"/>
              <!-- セグメント(3) -->
              <select class="select" v-model="filterWord" v-if="isFilter(i, 'seg_select')">
                <option v-for="(s, i) in segments" :key="i" :value="s">{{s}}</option>
              </select>
              <!-- スカウト設定(4) 次回スカウト(-) 過去スカウト(-) -->
              <select class="select" v-model="filterWord" v-if="isFilter(i, 'set_select')">
                <option v-for="(op, i) in [false, true]" :key="i" :value="op">{{op ? '設定済' : '未設定'}}</option>
              </select>
              <select class="select" v-model="filterWord" v-if="isFilter(i, 'history_select')">
                <option v-for="(h, i) in histories" :key="i" :value="h">{{h}}</option>
              </select>
              <!-- TODO: 次回スカウト(-) 過去スカウト(-) は 要望があれば追加 -->
              <!-- <select class="select" v-model="filterWord" v-if="isFilter(i, 'app_select')">
                <option value="-">-</option>
                <option v-for="(ap, i) in scouts" :key="i" :value="ap.name">{{ap.name}}</option>
              </select> -->
              <!-- スカウト回数(5)、直近1ヶ月での訪問回数(6)、直近6ヶ月での訪問回数(7)、直近1ヶ月の合計滞在時間(8)、会話数(13) -->
              <div style="display: flex; align-items: center; width: 95%;" v-if="isFilter(i, 'number')">
                <span style="font-size: 12px; width: 100%;">{{getPeriodStr('number')}}</span>
              </div>
              <div style="display: flex; align-items: center; width: 95%;" v-if="isFilter(i, 'number')">
                <input type="number" step="1" min="0" class="input is-small" style="width: 95%;" v-model="filterMin"/>
                〜
                <input type="number" step="1" min="0" class="input is-small" style="width: 95%;" v-model="filterMax"/>
              </div>
              <!-- 直近訪問日(5) -->
              <div style="display: flex; align-items: center; width: 250px;" v-if="isFilter(i, 'date')">
                <span style="font-size: 12px; width: 100%;">{{getPeriodStr('date')}}</span>
              </div>
              <div style="display: flex; align-items: center; width: 250px;" v-if="isFilter(i, 'date')">
                <!-- FROMカレンダー -->
                <b-datepicker
                  locale="ja-JP"
                  style="margin-right: 8px;"
                  size="is-small"
                  placeholder="FROM"
                  icon="calendar-today"
                  :mobile-native="false"
                  :show-week-number="false"
                  v-model="fromDate"
                >
                </b-datepicker>
                〜
                <!-- TOカレンダー -->
                <b-datepicker
                  locale="ja-JP"
                  style="margin-left: 8px; margin-right: 8px;"
                  size="is-small"
                  placeholder="TO"
                  icon="calendar-today"
                  :mobile-native="false"
                  :show-week-number="false"
                  v-model="toDate"
                >
                </b-datepicker>
              </div>
              <!-- ロボとの会話(12) -->
              <select class="select" v-model="filterWord" v-if="isFilter(i, 'exist_select')">
                <option v-for="(sc, i) in [false, true]" :key="i" :value="sc">{{sc ? 'あり' : 'なし'}}</option>
              </select>
              <!-- フィルター条件設定 -->
              <div style="display: flex; justify-content: center; margin-top: 8px;">
                <button class="button is-small is-primary" style="margin-right: 8px; width: 80px;" @click="addFilter(t, i)">適用</button>
                <button class="button is-small" style="width: 80px;" @click="clearFilter()">閉じる</button>
              </div>
            </div>
            <!-- ソート設定 -->
            <button class="sort-button" @click="idxSort = i; idxFilter = -1" v-if="isFilter(i, 'sort')">
              <!-- 昇順アイコン -->
              <span class="mdi mdi-sort-ascending" v-if="sortAsc && !sortDesc && sortIdx === i"></span>
              <!-- 降順アイコン -->
              <span class="mdi mdi-sort-descending" v-else-if="!sortAsc && sortDesc && sortIdx === i"></span>
              <!-- 未ソートアイコン -->
              <span class="mdi mdi-sort" v-else></span>
            </button>
            <div style="position: absolute; right: 0; width: auto; padding: 8px; top: 45px; background: #f8f8f8; color: #2c3e50; border: solid thin #ccc;" v-if="i === idxSort">
              <!-- 昇順 -->
              <div>
                <button class="button is-small" style="width: 80px;" @click="listSort(i, true, false)" :disabled="sortAsc && !sortDesc && sortIdx===i">
                  <span class="mdi mdi-sort-ascending">昇順</span>
                </button>
              </div>
              <!-- 降順 -->
              <div>
                <button class="button is-small" style="width: 80px;" @click="listSort(i, false, true)" :disabled="!sortAsc && sortDesc && sortIdx===i">
                  <span class="mdi mdi-sort-descending">降順</span>
                </button>
              </div>
              <!-- 閉じる -->
              <div>
                <button class="button is-small" style="width: 80px;" @click="clearFilter()">閉じる</button>
              </div>
            </div>
          </th>
        </tr>
        <tr style="max-height: 50px; min-height: 50px; height: 50px;" v-for="(sk, index) in notArchivedSeekers" :key="index" @keydown.enter="changeManage($event, sk)">
          <!-- チェックボックス -->
          <td style="overflow-y: visible; min-width: 50px; vertical-align: middle;">
            <b-checkbox v-model="selectedGroup" :native-value="sk" style="margin-left: 4px; margin-top: 8px;" :disabled="isSetScout(sk.scout_history)"></b-checkbox>
          </td>
          <!-- 会話履歴 / スカウト返信履歴 / お問い合わせ履歴 -->
          <td style="vertical-align: middle; overflow: unset;">
            <div class="button-wrapper">
              <div class="tooltip" @click="$emit('sendMessage', sk)">
                <button class="button is-info is-small"><span class="mdi mdi-comment"></span></button>
                <div class="tooltip-balloon">会話履歴</div>
              </div>
              <div class="tooltip" @click="$emit('scoutReplyHistory', sk)">
                <button class="button is-info is-small"><span class="mdi mdi-reply"></span></button>
                <div class="tooltip-balloon">スカウト<br>返信履歴</div>
              </div>
              <div class="tooltip" @click="$emit('contactHistory', sk)">
                <button class="button is-info is-small"><span class="mdi mdi-account-location"></span></button>
                <div class="tooltip-balloon">お問い合わせ履歴</div>
              </div>
            </div>
          </td>
          <!-- 訪問者名 -->
          <td style="vertical-align: middle;">
            <p style="text-align: left;">{{sk.name}}</p>
            <p style="text-align: left;">{{sk.email}}</p>
            <p style="font-size: 8px; text-align: left; color:#808080;">{{getElapsedTime(sk)}}</p>
          </td>
          <!-- タグ -->
          <td style="vertical-align: middle;">
            <template v-if="sk.seeker_tag_history.length > 0">
              <div class="tag-box">
                <b-tag style="margin: 2px;" v-for="(t, i) in tagFilter(sk.seeker_tag_history)" :key="i + '-tag-child'" type="is-info">{{t.name}}</b-tag>
              </div>
            </template>
            <template v-else>
              -
            </template>
          </td>
          <!-- セグメント -->
          <td style="vertical-align: middle;">
            <p style="text-align: left;">{{getFlg(sk)}}</p>
          </td>
          <!-- スカウト設定 / 次回スカウト -->
          <td style="max-width: 300px; vertical-align: middle; overflow: unset; display: flex; position: relative; flex-wrap: wrap;">
            <div style="width: 100%; display: flex;">
              <ScoutSet :skProp="sk" :scoutsProp="scouts" :isFinished="isSetScout(sk.scout_history)"/>
            </div>
            <ScoutHistoryView :schisProp="sk.scout_history" :scouts="scouts"/>
          </td>
          <!-- スカウト回数 -->
          <td style="vertical-align: middle;">
            {{sk.scout_history.length}}
          </td>
          <!-- 直近訪問日 -->
          <td style="vertical-align: middle;">
            {{sk.rooms ? new Date(sk.rooms.updated_at).toLocaleString('ja-JP') : sk.rooms}}
          </td>
          <!-- 直近1ヶ月での訪問回数 -->
          <td style="vertical-align: middle;">
            {{getCount(sk, 1)}}
          </td>
          <!-- 直近6ヶ月での訪問回数 -->
          <td style="vertical-align: middle;">
            {{getCount(sk, 6)}}
          </td>
          <!-- 直近1ヶ月の合計滞在時間 -->
          <td style="vertical-align: middle;">
            {{getSpendTime(sk, 1)}}秒
          </td>
          <!-- 最長滞在ページ -->
          <td style="vertical-align: middle;">
            <a class="-url" :href="getLongestSpendPage(sk)" target="_blank">{{getLongestSpendPage(sk)}}</a>
          </td>
          <!-- アクセス元 -->
          <td style="vertical-align: middle;">
            <template v-if="sk.seeker_history.length > 0 && sk.seeker_history[0].referrer">
              <a class="-url" :href="sk.seeker_history[0].referrer" target="_blank">{{sk.seeker_history[0].referrer}}</a>
            </template>
            <template v-else>-</template>
          </td>
          <!-- ロボとの会話 -->
          <td style="overflow: scroll; vertical-align: middle;">
            {{sk.conv_count > 0 ? 'あり' : 'なし'}}
          </td>
          <!-- 会話数 -->
          <td style="vertical-align: middle;">
            {{sk.conv_count}}
          </td>
        </tr>
      </table>
      <div class="recruit-footer">
        <b-select size="is-small" v-model="perPage" @input="setPages()">
          <option value="30" selected>30件表示</option>
          <option value="50">50件表示</option>
          <option value="100">100件表示</option>
          <option value="150">150件表示</option>
          <option value="200">200件表示</option>
        </b-select>
        <b-pagination
          style="width: 100%; align-items: flex-start; font-size: 14px; padding-left: 16px; padding-right: 8px;"
          :total="scoutCount"
          :current.sync="seekersPages"
          :per-page="perPage">
          <b-pagination-button
            slot-scope="props"
            :page="props.page"
            tag="button">
            {{ props.page.number }}
          </b-pagination-button>
          <b-pagination-button
            slot="previous"
            slot-scope="props"
            :page="props.page"
            tag="button">
            ＜
          </b-pagination-button>
          <b-pagination-button
            slot="next"
            slot-scope="props"
            :page="props.page"
            tag="button">
              ＞
          </b-pagination-button>
        </b-pagination>
      </div>
    </div>
    <div style="width: 100%; height: calc(100vh - 100px); background: #FEFEFE; display: flex; justify-content: center; align-items: center;" v-else-if="isScoutSeekerLoading">
      <div>
        <span class="mdi mdi-spin mdi-loading mdi-48px"></span>
      </div>
    </div>
    <div style="width: 100%; height: calc(100vh - 100px); background: #FEFEFE; display: flex; justify-content: center; align-items: center;" v-else>
      <div>
        <p>表示できるタレントプールがございません。</p>
      </div>
    </div>
    <!-- Footer -->
    <div class="select-footer" v-if="selectedGroup.length > 0">
      <img style="width: 80px; height: 80px; background: white; border-radius: 50%; margin-left: 20px;" src="@/assets/lp/hrmonster.png" />
      <div style="margin-bottom: 8px;" class="message-box">
        <p>
          今、{{selectedGroup.length}}件選択中です！
          どのアクションを行いますか？
        </p>
        <template v-if="isScoutAction">
          <p style="margin-bottom: 8px;">※既にスカウトが設定済の訪問者に対しては設定されません。</p>
          <select class="select" v-model="newScouts">
            <option :value="s.pk" v-for="(s, idxP) in scouts" :key="idxP">{{s.name}}</option>
          </select>
          <button class="button is-small" style="margin-left: 4px;" @click="createScoutHistoryAll()" :disabled="!newScouts">設定</button>
          <button class="button is-small is-danger" @click="isScoutAction = false">戻る</button>
        </template>
        <div style="display: flex; padding: 8px;" v-if="!isScoutAction">
          <button class="button is-small -right-8px" @click="isScoutAction = true">スカウトを設定する</button>
          <button class="button is-small" @click="updateSeekerSubscribe()">応募者管理画面へ設定する</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import ModalCreate from '@/views/DashBoard/Manage/ModalCreate'
import ModalEdit from '@/views/DashBoard/Manage/ModalEdit'
import ModalEditDate from '@/components/ui/ModalEditDate'

export default {
  name: 'ScoutTableView',
  componentName: 'ScoutTableView',
  components: {
    ModalCreate,
    ModalEdit,
    ModalEditDate,
    ScoutSet: {
      template: `
                  <div style="display: flex; align-items: center;">
                    <template v-if="isFinished && !isUpdateScout && !isScoutLoading">
                      <div class="nextApproach-table">{{getScoutName()}}</div>
                      <div style="width: 20%; display: flex; align-items: center;">
                        <button class="button is-small" style="margin-left: 4px;" @click="isUpdateScout=!isUpdateScout;upScoutHistory=getScoutPk()">編集</button>
                        <button class="button is-small" style="margin-left: 4px;" @click="deleteScoutHistory()">削除</button>
                      </div>
                    </template>
                    <template v-if="isFinished && !isUpdateScout && isScoutLoading">
                      <span class="mdi mdi-loading mdi-spin mdi-36px" />
                    </template>
                    <template v-if="!isFinished">
                      <select class="select nextApproach-select" v-model="newScoutHistory">
                        <option :value="s.pk" v-for="(s, idxP) in scoutsProp" :key="idxP">{{s.name}}</option>
                      </select>
                      <div style="width: 20%; display: flex; align-items: center;">
                        <button class="button is-small" style="margin-left: 4px;" @click="createScoutHistory()" :disabled="!newScoutHistory">設定</button>
                        <button class="button is-small" style="margin-left: 4px;" @click="newScoutHistory = null" v-if="newScoutHistory">取消</button>
                      </div>
                    </template>
                    <template v-if="isUpdateScout">
                      <select class="select nextApproach-select" v-model="upScoutHistory">
                        <option :value="s.pk" v-for="(s, idxP) in scoutsProp" :key="idxP">{{s.name}}</option>
                      </select>
                      <div style="width: 20%; display: flex; align-items: center;">
                        <button class="button is-small" style="margin-left: 4px;" @click="updateScoutHistory()">更新</button>
                        <button class="button is-small" style="margin-left: 4px;" @click="isUpdateScout=!isUpdateScout">取消</button>
                      </div>
                    </template>
                  </div>
                `,
      props: ['skProp', 'scoutsProp', 'isFinished'],
      data () {
        return {
          newScoutHistory: null,
          upScoutHistory: null,
          isUpdateScout: false,
          isScoutLoading: false
        }
      },
      methods: {
        createScoutHistory () {
          let createScout = {
            seeker: this.skProp.id,
            scout: this.newScoutHistory,
            is_finished: false,
            finished_status: 0
          }
          this.$store.dispatch('directtalk/createScoutHistory', createScout)
        },
        updateScoutHistory () {
          this.isScoutLoading = true
          let updateScout = {
            pk: this.updateScoutPk(),
            scout: this.upScoutHistory,
            is_finished: false,
            finished_status: 0
          }
          this.$store.dispatch('directtalk/updateScoutHistory', updateScout)
          this.isUpdateScout = false
          this.isScoutLoading = false
        },
        deleteScoutHistory () {
          this.isScoutLoading = true
          let deleteScout = this.updateScoutPk()
          this.$store.dispatch('directtalk/deleteScoutHistory', deleteScout)
          this.isUpdateScout = false
          this.newScoutHistory = null
          this.isScoutLoading = false
        },
        getScoutName () {
          if (this.skProp.scout_history.length === 0) return '-'
          for (let s2 of this.scoutsProp) {
            if (this.skProp.scout_history[this.skProp.scout_history.length - 1].scout === s2.pk) return s2.name
          } 
          this.newScoutHistory = null
          return this.skProp.scout_history.pop()
        },
        getScoutPk () {
          for (let s2 of this.scoutsProp) {
            if (this.skProp.scout_history[this.skProp.scout_history.length - 1].scout === s2.pk) return s2.pk
          } 
        },
        updateScoutPk () {
          for (let s2 of this.scoutsProp) {
            if (this.skProp.scout_history[this.skProp.scout_history.length - 1].scout === s2.pk) {
              return this.skProp.scout_history[this.skProp.scout_history.length - 1].pk
            }
          }
        }
      }
    },
    ScoutHistoryView: {
      template: `
                <button
                  class="button is-primary is-small"
                  style="margin-left: 8px;"
                  @click="isOpen = true"
                  v-if="schisProp.length > 0 && !getIsOpen">履歴</button>
                <div style="width: 100%; padding: 8px;" v-else-if="schisProp.length > 0 && getIsOpen">
                  <p style="width: 100%; text-align: left;">過去のスカウト履歴</p>
                  <div style="display: flex; overflow-y: scroll; align-items: flex-start; flex-direction: column-reverse; height: 64px;" v-if="schisProp.length > 0">
                    <p style="text-align: left; word-break: normal; margin-right: 4px;" v-for="(sch, idx) in schisProp" :key="idx">
                      ・{{getScoutName(sch)}}
                    </p>
                  </div>
                  <p v-else>-</p>
                  <button class="button is-primary is-small" @click="isOpen=false">閉じる</button>
                </div>
                `,
      props: ['schisProp', 'scouts'],
      data () {
        return {
          isOpen: false
        }
      },
      computed: {
        getIsOpen () {
          return this.isOpen
        }
      },
      methods: {
        getScoutName (sch) {
          for (let s2 of this.scouts) {
            if (sch.scout === s2.pk) return s2.name
          }
          return '-'
        }
      }
    }
  },
  computed: {
    ...mapState('auth', ['user', 'companyColumnSetting', 'scouts']),
    ...mapState('directtalk', ['scoutSeekers', 'scoutCount', 'isScoutSeekerLoading', 'isApplyListNone', 'downloadCSV', 'isMakingCSV', 'resumeLoading', 'pdfFile', 'isOCRReading', 'ocrData', 'getSeekerType', 'isSavingCustomColumn', 'isFilteringError']),
    notArchivedSeekers () {
      let skList = []
      for (let sk of this.scoutSeekers) {
        if (sk.is_archive === this.archiveSwitch) skList.push(sk)
      }
      return skList
    }
  },
  props: {
    isDataOpen: {
      type: Boolean,
      default: false,
      require: true
    },
  },
  data () {
    return {
      isScoutAction: false,
      isSaving: false,
      isOpenOtherInfomation: false,
      tempOtherInfomation: {},
      segments: [
        '-',
        '有望フラグ',
        '自社動機付けチャンスフラグ'
      ],
      headers: [
        '履歴',
        '訪問者',
        'タグ',
        'セグメント',
        'スカウト設定',
        // '次回スカウト',
        // '過去スカウト',
        'スカウト回数',
        '直近訪問日',
        '直近1カ月での訪問回数',
        '直近6カ月での訪問回数',
        '直近1カ月の合計滞在時間',
        '最長滞在ページ',
        'アクセス元',
        'ロボとの会話',
        '会話数'
      ],
      addFile: null,
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      template: [''],
      searchWords: null,
      archiveSwitch: false,
      changeDate: null,
      data: '',
      select: null,
      seekersPages: 1,
      orSwitch: false,
      filtered: {
        filters : [],
        sortIdx : -1,
        sortAsc : false,
        sortDesc: false
      },
      filterWord: null,
      fromDate: null,
      toDate: null,
      filterMin: null,
      filterMax: null,
      sortIdx: -1,
      sortAsc: false,
      sortDesc: false,
      idxFilter: -1,
      idxSort: -1,
      selectedGroup: [],
      isAllSelected: false,
      newScouts: null,
      perPage: 30,
      lastOperation: '',
      histories: ['スカウト返信有り', 'お問い合わせ履歴有り']
    }
  },
  watch: {
    seekersPages () {
      let el = document.querySelector('.recruit-table')
      el.scrollTo(0, 0)

      // フィルタリング実行
      this.execFiltering('scout')
    },
    addFile () {
      let reader = new FileReader()
      console.log(this.addFile)
      reader.onload = (e) => {
        console.log(e)
        let createFiles = new FormData()
        createFiles.append('file', this.addFile)
        createFiles.append('name', this.addFile.name)
        createFiles.append('seeker', this.seekers[this.changeIndex].id)
        this.$store.dispatch('directtalk/createSeekerFiles', createFiles)
      }
      reader.readAsDataURL(this.addFile)
    },
    fileLeft () {
      let reader = new FileReader()
      console.log(this.fileLeft)
      reader.onload = (e) => {
        console.log(e)
        this.ocrResumeRows.push({
          filename: this.fileLeft.name,
          data: e.target.result.replace(/^.*,/, '')
        })
      }
      reader.readAsDataURL(this.fileLeft)
    },
    fileRight () {
      let reader = new FileReader()
      reader.onload = (e) => {
        console.log(e)
        this.ocrResumeRows.push({
          filename: this.fileRight.name,
          data: e.target.result.replace(/^.*,/, '')
        })
      }
      reader.readAsDataURL(this.fileRight)
    },
    isFilteringError () {
      if (this.isFilteringError) {
        // フィルタリングでエラーあり
        if (this.lastOperation === 'sorting') {
          // ソートでエラーの場合はソート解除
          this.idxSort = -1
          this.listSort(this.idxSort, false, false)
        } else if (this.lastOperation === 'filtering') {
          // フィルタリングでエラーの場合は最後のフィルタリングを解除
          this.deleteFilter(this.filtered['filters'].length - 1)
        }
      }
    }
  },
  mounted () {
    // フィルタリング実行
    this.execFiltering('scout')
  },
  methods: {
    // フィルター表示設定
    isFilter (idx, type) {
      let result = false
      switch (idx) {
        case 0:
          // 会話履歴(フィルタ対象、選択)
          result = (type === 'filter' || type === 'history_select')
          break
        case 1:
          // 訪問者(フィルタ対象、テキスト入力、ソート可)
          result = (type === 'filter' || type === 'text' || type === 'sort')
          break
        case 2:
          // タグ(フィルタ対象、選択(フラグ名)、ソート可)
          result = (type === 'filter' || type === 'text')
          break
        case 3:
          // セグメント(フィルタ対象、選択(フラグ名)、ソート可)
          result = (type === 'filter' || type === 'seg_select' || type === 'sort')
          break
        case 4:
          // スカウト設定(フィルタ対象、選択(未設定、設定済)、ソート可)
          result = (type === 'filter' || type === 'set_select' || type === 'sort')
          // 過去スカウト(フィルタ対象、選択(スカウト名)、ソート可)
          // TODO:この処理も加えること
          // result = (type === 'filter' || type === 'app_select' || type === 'sort')
          break
        case 5:
          // スカウト回数(フィルタ対象、数値入力、ソート可)
          result = (type === 'filter' || type === 'number' || type === 'sort')
          break
        case 6:
          // 直近訪問日(フィルタ対象、日付選択、ソート可)
          result = (type === 'filter' || type === 'date' || type === 'sort')
          break
        case 7:
          // 直近1ヶ月での訪問回数(フィルタ対象、数値入力、ソート可)
          result = (type === 'filter' || type === 'number' || type === 'sort')
          break
        case 8:
          // 直近6ヶ月での訪問回数(フィルタ対象、数値入力、ソート可)
          result = (type === 'filter' || type === 'number' || type === 'sort')
          break
        case 9:
          // 直近1ヶ月の合計滞在時間(フィルタ対象、数値入力、ソート可)
          result = (type === 'filter' || type === 'number' || type === 'sort')
          break
        case 10:
          // 最長滞在ページ(フィルタ対象、テキスト入力、ソート可)
          result = (type === 'filter' || type === 'text' || type === 'sort')
          break
        case 11:
          // アクセス元(フィルタ対象、テキスト入力、ソート可)
          result = (type === 'filter' || type === 'text' || type === 'sort')
          break
        case 12:
          // ロボとの会話(フィルタ対象、選択(あり、なし)、ソート可)
          result = (type === 'filter' || type === 'exist_select' || type === 'sort')
          break
        case 13:
          // 会話数(フィルタ対象、数値入力、ソート可)
          result = (type === 'filter' || type === 'number' || type === 'sort')
          break
        default:
          result = false
          break
      }
      return result
    },
    isFilterSet (index) {
      // フィルター設定チェック
      let isSet = false
      for (const filter of this.filtered['filters']) {
        if (filter.index === index) {
          // フィルター設定あり
          isSet = true
          break
        }
      }
      return isSet
    },
    getPeriodStr (target) {
      if (target === 'number') {
        if (!this.filterMin && !this.filterMax && this.filterMin !== 0 && this.filterMax !== 0) {
          return '範囲指定してください'
        } else if (this.filterMin >= 0 && !this.filterMax && this.filterMax !== 0) {
          return '上限なし'
        } else if (!this.filterMin && this.filterMin !== 0 && this.filterMax >= 0) {
          return '下限なし'
        } else {
          return '範囲指定あり'
        }
      } else if (target === 'date') {
        if (!this.fromDate && !this.toDate) {
          return '範囲指定してください'
        } else if (this.fromDate && !this.toDate) {
          return '上限なし'
        } else if (!this.fromDate && this.toDate) {
          return '下限なし'
        } else {
          return '範囲指定あり'
        }
      } else {
        return ''
      }
    },
    getFlg (sk) {
      if (!sk.seeker_history[0]) {
        return '-'
      } else if (sk.seeker_history[0].referrer) {
        if (sk.seeker_history[0].referrer.indexOf('employment.en-japan.com') >= 0 ||
            sk.seeker_history[0].referrer.indexOf('en-gage.net') >= 0 ||
            sk.seeker_history[0].referrer.indexOf('type.jp') >= 0 ||
            sk.seeker_history[0].referrer.indexOf('rikunavi.com') >= 0 ||
            sk.seeker_history[0].referrer.indexOf('mynavi.jp') >= 0
        ) {
          return '自社動機付けチャンスフラグ'
        } else if (this.getSpendTime(sk, 1) > 300) {
          return '自社動機付けチャンスフラグ'
        } else if (this.getCount(sk, 1) > 3) {
          return '有望フラグ'
        } else {
          return '-'
        }
      } else if (this.getSpendTime(sk, 1) > 300) {
        return '自社動機付けチャンスフラグ'
      } else if (this.getCount(sk, 1) > 3) {
        return '有望フラグ'
      } else {
        return '-'
      }
    },
    filterValidation (t, i) {
      // 履歴選択チェック
      if (this.isFilter(i, 'history_select') && i === 0 && !this.filterWord) {
        alert(this.headers[i] + 'のフィルター条件を入力してください。')
        return true
      }
      // 訪問者入力チェック
      if (this.isFilter(i, 'text') && i === 1 && !this.filterWord) {
        alert(this.headers[i] + 'のフィルター条件を入力してください。')
        return true
      }
      // スカウト設定選択チェック
      if (this.isFilter(i, 'set_select') && this.filterWord !== false && this.filterWord !== true) {
        alert(this.headers[i] + 'のフィルター条件を選択してください。')
        return true
      }
      // セグメント選択チェック
      if (this.isFilter(i, 'seg_select') && !this.filterWord) {
        alert(this.headers[i] + 'のフィルター条件を選択してください。')
        return true
      }
      // 次回スカウト、過去スカウト選択チェック
      if (this.isFilter(i, 'app_select') && !this.filterWord) {
        alert(this.headers[i] + 'のフィルター条件を選択してください。')
        return true
      }
      // 日付チェック
      if (this.isFilter(i, 'date') && !this.fromDate && !this.toDate) {
        alert(this.headers[i] + 'FROMとTOのどちらか一方は入力してください。')
        return true
      } else if (this.isFilter(i, 'date') && this.fromDate && this.toDate && this.fromDate > this.toDate) {
        alert(this.headers[i] + 'に入力した日付のFROMとTOの順番を確認してください。')
        return true
      }
      // 数値チェック
      if (this.isFilter(i, 'number') && ((!this.filterMin && !this.filterMax) || (this.filterMin < 0 && this.filterMax < 0))) {
        alert(this.headers[i] + '下限と上限のどちらか一方は0以上を入力してください。')
        return
      } else if (this.filterMin < 0 || this.filterMax < 0) {
        alert(this.headers[i] + 'の値は0以上を入力してください。')
        return true
      }
      this.filterMin = parseInt(this.filterMin)
      this.filterMax = parseInt(this.filterMax)
      if (this.isFilter(i, 'number') && this.filterMin >= 0 && this.filterMax >= 0 && this.filterMin > this.filterMax) {
        alert(this.headers[i] + 'に入力した下限と上限の順番を確認してください。')
        return true
      }
      // ロボとの会話選択チェック
      if (this.isFilter(i, 'exist_select') && this.filterWord !== false && this.filterWord !== true) {
        alert(this.headers[i] + 'のフィルター条件を選択してください。')
        return true
      }
      // ひっかからなければfalseを返す
      return false
    },
    // フィルター設定追加
    addFilter (t, i) {
      if (this.filterValidation(t, i)) return

      // フィルター追加
      this.filtered['filters'].push({
        index    : i,
        name     : t,
        data     : (this.isFilter(i, 'text') && !this.filterWord) ? '-' : this.filterWord,
        type     : i,
        fromDate : this.fromDate,
        toDate   : this.toDate,
        filterMin: (!this.filterMin && this.filterMin !== 0) ? -1 : this.filterMin,
        filterMax: (!this.filterMax && this.filterMax !== 0) ? -1 : this.filterMax
      })

      // ページは先頭に戻す
      this.seekersPages = 1

      // フィルタリング実行
      this.execFiltering(null)

      // 初期化
      this.filterWord   = null
      this.fromDate     = null
      this.toDate       = null
      this.filterMin    = null
      this.filterMax    = null
      this.idxFilter    = -1

      // 操作保存
      this.lastOperation = 'filtering'
      this.$store.dispatch('directtalk/changeFilterFlg', true)
    },
    // ソート設定
    listSort (idx, isAsc, isDesc) {
      this.sortIdx  = idx
      this.sortAsc  = isAsc
      this.sortDesc = isDesc

      // フィルタリング実行
      this.execFiltering(null)

      // 操作保存
      this.lastOperation = 'sorting'
      if (isAsc || isDesc) {
        this.$store.dispatch('directtalk/changeSortFlg', true)
      } else {
        this.$store.dispatch('directtalk/changeSortFlg', false)
      }
    },
    // フィルター条件削除
    deleteFilter (i) {
      this.filtered['filters'].splice(i, 1)

      // フィルタリング実行
      this.execFiltering(null)

      // 操作保存
      this.lastOperation = 'filter_delete'
      this.$store.dispatch('directtalk/changeFilterFlg', false)
    },
    // 全フィルター解除
    deleteFilterAll () {
      this.filtered['filters'] = []

      // フィルタリング実行
      this.execFiltering(null)

      // 操作保存
      this.lastOperation = 'all_filter_delete'
      this.$store.dispatch('directtalk/changeFilterFlg', false)
    },
    // フィルタリング実行
    execFiltering (id) {
      // ソート設定が昇順または降順の場合は追加する
      let sort_filter = JSON.parse(JSON.stringify(this.filtered))
      if (this.isFilter(this.sortIdx, 'sort') &&
        ((this.sortAsc && !this.sortDesc) ||
        (!this.sortAsc && this.sortDesc))) {
        // ソート用フィルター一時追加
        sort_filter['filters'].push({
          index    : this.sortIdx,
          name     : this.headers[this.sortIdx],
          data     : null,
          type     : this.sortIdx,
          fromDate : null,
          toDate   : null,
          filterMin: -1,
          filterMax: -1
        })
      } else {
        // ソートが指定されていないので初期化しておく
        this.sortIdx  = -1
        this.sortAsc  = false
        this.sortDesc = false
      }

      // ソート条件
      sort_filter['sortIdx']  = this.sortIdx
      sort_filter['sortAsc']  = this.sortAsc
      sort_filter['sortDesc'] = this.sortDesc

      // フィルタリングデータ設定
      const filter = {
        id      : id !== null ? id : 'scout?page=' + this.seekersPages + '&perPage=' + this.perPage,
        filtered: sort_filter,
        page    : this.seekersPages,
        perPage : this.perPage
      }
      console.debug('Filtering data: ' + JSON.stringify(filter))

      // フィルタリング実行
      this.$store.dispatch('directtalk/filteredSeeker', filter)
      this.clearFilter()
    },
    // フィルター設定クリア
    clearFilter () {
      this.filterWord = null
      this.fromDate   = null
      this.toDate     = null
      this.filterMin  = null
      this.filterMax  = null
      this.idxFilter  = -1
      this.idxSort    = -1
      this.$store.dispatch('directtalk/changeFilterFlg', false)
    },
    allSelect () {
      console.debug('*** Start *** allSelect')
      if (!this.isAllSelected) {
        this.selectedGroup = []
      } else {
        for (let sk of this.scoutSeekers) {
          if (!this.isSetScout(sk.scout_history)) {
            this.selectedGroup.push(sk)
          }
        }
      }
    },
    createScoutHistoryAll () {
      for (let s of this.selectedGroup) {
        if (!this.isSetScout(s.scout_history)) {
          let createScout = {
            seeker: s.id,
            scout: this.newScouts,
            is_finished: false,
            finished_status: 0
          }
          this.$store.dispatch('directtalk/createScoutHistory', createScout)
        }
      }
      this.selectedGroup = []
      this.isScoutAction = false
      this.isAllSelected = false
    },
    updateSeekerSubscribe () {
      for (let s of this.selectedGroup) {
        let updateSeeker = s
        s.is_subscribe = true
        s.subscribe_date = new Date()
        s.subscribe_count = 1
        s.recruit_route = 'スカウト返信者'
        this.$store.dispatch('directtalk/updateSeeker', updateSeeker)
      }
      this.selectedGroup = []
      this.isScoutAction = false
      this.isAllSelected = false
    },
    isSetScout (schis) {
      if (schis.length === 0) return false
      else return !schis[schis.length - 1].is_finished
    },
    getCount (sk, month) {
      var cnt = 0
      for (let h of sk.seeker_history) {
        if (h.created_at) {
          // 当日から1ヶ月前の日付以降ならカウントする
          if (moment(h.created_at) >= moment().subtract(month, 'months')) {
            cnt++
          }
        }
      }
      return cnt
    },
    getSpendTime (sk, month) {
      var cnt = 0
      for (let h of sk.seeker_history) {
        if (h.created_at && h.ended_at) {
          // 当日から1ヶ月前の日付以降ならカウントする
          if (moment(h.created_at) >= moment().subtract(month, 'months')) {
            if (h.created_at && h.ended_at) cnt += moment(h.ended_at).diff(moment(h.created_at), 'seconds')
          }
        }
      }
      if (cnt === 0) return '- '
      else return cnt
    },
    getLongestSpendPage (sk) {
      var urlList = []
      for (let h of sk.seeker_history) {
        let flg = false
        for (let u of urlList) {
          if (u.url === h.url) {
            flg = true
            if (h.created_at && h.ended_at) {
              u.cnt += moment(h.ended_at).diff(moment(h.created_at), 'seconds')
            }
          }
        }
        // ない場合は追加＆加算
        if (!flg) {
          if (h.created_at && h.ended_at) {
            urlList.push({
              url: h.url,
              cnt: moment(h.ended_at).diff(moment(h.created_at), 'seconds')
            })
          }
        }
      }
      if (urlList.length > 0) {
        return urlList.reduce((a, b) => a.cnt > b.cnt ? a : b).url
      } else {
        return '-'
      }
    },
    getAge (date) {
      const y2 = date.getFullYear().toString().padStart(4, '0')
      const m2 = (date.getMonth() + 1).toString().padStart(2, '0')
      const d2 = date.getDate().toString().padStart(2, '0')
      const today = new Date()
      const y1 = today.getFullYear().toString().padStart(4, '0')
      const m1 = (today.getMonth() + 1).toString().padStart(2, '0')
      const d1 = today.getDate().toString().padStart(2, '0')
      return Math.floor((Number(y1 + m1 + d1) - Number(y2 + m2 + d2)) / 10000)
    },
    saveDate (data) {
      console.log(data.date)
      let upsk = data.sk
      upsk.birth = data.date
      this.$store.dispatch('directtalk/updateSeeker', upsk)
    },
    openOtherInfo (sk) {
      if (!sk.other_infomation[0]) {
        alert('外部連携情報はありません。')
        return
      }
      this.isOpenOtherInfomation = true
      this.tempOtherInfomation = sk.other_infomation
    },
    isCustomColumn (id, columnList) {
      for (let c of columnList) {
        if (c.column === id) return true
      }
      return false
    },
    getPath (sk) {
      // 媒体
      if (sk.recruit_route) return sk.recruit_route
      // HR Monster
      if (!sk.url) return 'その他'
      else if (sk.url.indexOf('hr-monster.io/recruit/') >= 0) return 'HRモンスター求人'
      else if (sk.url) return 'HRモンスター'
      else return 'その他'
    },
    getStatus (status, flg) {
      console.debug('*** Start *** getStatus')
      console.debug('status: ' + JSON.stringify(status))
      console.debug('flg: ' + JSON.stringify(flg))
      if (flg) return '履歴書送付'
      switch (status) {
        case 0:
          console.debug('Apply')
          return '応募'
        case 1:
          console.debug('During interview adjustment')
          return '面接調整中'
        case 2:
          console.debug('During interview')
          return '面接中'
        case 3:
          console.debug('Hiring')
          return '採用'
        case 4:
          console.debug('not adopted')
          return '不採用'
        case 5:
          console.debug('on hold')
          return '保留'
        case 7:
          return '履歴書受付' 
      }
      console.debug('*** End *** getStatus')
    },
    getDate (date) {
      var time = new Date(date)
      if (date == null) return null
      else return time.getFullYear() + '/' + (time.getMonth() + 1) + '/' + time.getDate() + ' ' + time.getHours() + ':' + ('00' + time.getMinutes()).slice(-2)
    },
    getDateBack (time) {
      return time.getFullYear() + '-' + ('00' + (time.getMonth() + 1)).slice(-2) + '-' + ('00' + time.getDate()).slice(-2)
    },
    archiveSeeker (skData, flg) {
      let changeSeeker = skData
      skData.is_archive = flg
      this.$store.dispatch('directtalk/updateSeeker', changeSeeker)
      alert((flg ? 'アーカイブ' : 'アーカイブから元に戻') + 'しました。')
    },
    changeManage (event, skData) {   
      console.debug('*** Start *** changeManage')
      if (event.keyCode !== 13) return
      let changeSeeker = skData
      if (this.year > 1900) {
        changeSeeker.birth = new Date(this.year + '-' + this.month + '-' + this.date)
      } else {
        changeSeeker.birth = null
      }
      this.$store.dispatch('directtalk/updateSeeker', changeSeeker)
      for (let ca of changeSeeker.career) this.$store.dispatch('directtalk/updateCareer', ca)
      for (let qu of changeSeeker.qualification) this.$store.dispatch('directtalk/updateQualification', qu)
      for (let cu of changeSeeker.custom_column) {
        cu['id'] = skData.id
        this.$store.dispatch('directtalk/updateSeekerCustomColumns', cu)
      }
      console.debug('*** End *** changeManage')
    },
    createCustomColumn (sk, col) {
      let createCustom = {
        name: '',
        type: 0,
        content: '',
        select_list: '',
        column: col.pk,
        id: sk.id
      }
      this.$store.dispatch('directtalk/createSeekerCustomColumns', createCustom)
    },
    getElapsedTime (sk) {
      console.debug('*** Start *** getElapsedTime')
      if (!sk || !sk.rooms || !sk.rooms.updated_at) {
        return
      }
      var nowDate = new Date()
      var visitDate = new Date(sk.rooms.updated_at)
      var elapsed = (nowDate.getTime() - visitDate.getTime()) / 1000
      var elapsedTime = ''

      // 経過秒
      var elapsedSec   = Math.floor(elapsed)
      // 経過分
      var elapsedMin   = Math.floor(elapsed / 60)
      // 経過時間
      var elapsedHour  = Math.floor(elapsed / (60 * 60))
      // 経過日
      var elapsedDay   = Math.floor(elapsed / (60 * 60 * 24))
      // 経過月(アバウト)
      var elapsedMonth = Math.floor(elapsed / (60 * 60 * 24 * 30))
      // 経過年(アバウト)
      var elapsedYear  = Math.floor(elapsed / (60 * 60 * 24 * 30 * 12))

      if (elapsedSec <= 60) {
        // 60秒以内
        elapsedTime = elapsedSec.toString() + '秒前に訪問'
      } else if (elapsedMin <= 60) {
        // 60分以内
        elapsedTime = elapsedMin.toString() + '分前に訪問'
      } else if (elapsedHour <= 24) {
        // 24時間以内
        elapsedTime = elapsedHour.toString() + '時間前に訪問'
      } else if (elapsedDay <= 30) {
        // 30日以内
        elapsedTime = elapsedDay.toString() + '日前に訪問'
      } else if (elapsedMonth <= 12) {
        // 1年以内
        elapsedTime = elapsedMonth.toString() + 'ヶ月前に訪問'
      } else {
        // 1年以上
        elapsedTime = elapsedYear.toString() + '年以上前に訪問'
      }

      console.debug('*** End *** getElapsedTime')
      return elapsedTime
    },
    setPages () {
      // ページは先頭に戻す
      this.seekersPages = 1
      // フィルタリング実行
      this.execFiltering(null)
    },
    // タグ重複削除
    tagFilter (data) {
      let temp = []
      for (const d of data) temp = temp.concat(d.tag_name)
      return Array.from(new Map(temp.map(obj => [obj.pk, obj])).values())
    }
  }
}
</script>

<style scoped>
table td:not([align]), table th:not([align]) {
  text-align: center;
}
table {
  width: 100%;
  border-collapse:collapse;
  margin: 0 auto;
  display: block;
  overflow: scroll;
  height: calc(100% - 200px);
  table-layout: fixed;
}
td,th {
  min-width: 100px;
  padding: 8px;
  margin: auto;
  max-width: 350px;
  font-size: smaller;
}
td {
  text-align: left;
  overflow-y: scroll;
  padding: 8px;
  border-left: solid thin #FFCCEE;
}
td > div::-webkit-scrollbar {
  width:  5px;
  height: 5px;
  visibility: hidden;
}
th {
  background:#ffeeff;
  white-space: nowrap;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10000;
  vertical-align: middle;
}
table tr:nth-child(odd) {
  background:#ffeeff;
}
table tr:nth-child(even) {
  background:#fafafa;
}
.recruit-table {
  display: block;
  height: calc(100% - 50px);
  width: 100%;
  //overflow: scroll;
}
.recruit-table::-webkit-scrollbar {
  //width:  9px;
  //height: 9px;
  //visibility: hidden;
}
.recruit-box {
  width: calc(100% - 80px);
  height: 100%;
  margin: 0 auto;
  display: flex; flex-direction: column; justify-content: flex-start; align-items: center;
  background: #ffeeff;
  border-radius: 8px;
  margin-top: 16px;
}
.recruit-header {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  overflow-x: scroll;
}
.recruit-footer {
  width: 100%;
  height: 50px;
  display: flex; align-items: center;
}
.container-manage {
  height: calc(100vh - 80px);
  width: calc(100% - 200px);
  overflow-y: scroll;
}
.container-manage::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.main-box-data-open {
  width: 100%;
  height: calc(100vh - 440px);
  padding: 0;
}
.main-box-data-close {
  width: 100%;
  height: calc(100vh - 230px);
  padding: 0;
}
.cell-textbox {
  min-width: 100px;
  min-height: 50px;
  background: transparent; border: none; border-radius: 0; -webkit-appearance: none; box-shadow: none; height: 100%; width: 100%;
}
.filter-button {
  position: absolute;
  right: 18px;
  top: 10px;
  font-size: 14px;
  margin-left: 4px;
  background: transparent;
  color: #222;
  border: none;
  cursor: pointer;
  outline: 0;
}
.sort-button {
  position: absolute;
  right: 0;
  top: 10px;
  font-size: 14px;
  margin-left: 4px;
  background: transparent;
  color: #222;
  border: none;
  cursor: pointer;
  outline: 0;
}
.table-list {
  border: solid thin #ccc;
  height: calc(100vh - 180px);
  overflow: scroll;
}
.file-box {
  font-size: smaller;
  overflow: hidden;
  width: 100%;
  height: 16px;
  display: inline-flex;
}
.export-box {
  height: calc(100vh - 130px);
  width: 100%;
}
.export-body {
  height: calc(100vh - 187px);
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  display: -webkit-inline-box;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.export-body::-webkit-scrollbar {
  width:  0px !important;
  height: 10px !important;
  visibility: visible !important;
  background: white;
}
.export-list {
  margin: 20px;
  margin-right: 5px;
  margin-left:  10px;
  height: calc(100% - 40px);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background: rgba(200, 200, 200, 0.5);
  border-radius: 10px;
}
.export-list-header {
  background: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  width: 200px;
  height: 40px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  color: white;
  font-size: 16px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.export-list-body {
  border-radius: 10px;
  width: 190px;
  text-align: center;
  color: black;
  font-size: 16px;
  margin: 5px;
  margin-bottom: 0;
  padding: 10px;
  background: white;
  min-height: 44px;
}
.export-header {
  height: 50px;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.add-box {
  margin: 20px;
  margin-left: 5px;
  margin-right: 10px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  /* padding: 20px; */
  width: 210px;
  height: 40px;
}
.date-box {
  width: 40%;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between
}
.option-box {
  width: 60%;
  padding-right: 10px; 
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px;
  overflow: scroll;
}
.resume-btn {
  border-radius: 50%;
  height: 36px;
  width: 36px;
  font-size: 16px;
}

.wrapper-cover-img {
  position: relative;
}

.input-box {
  text-align: left;
  width: 100%;
  display: flex;
  border-bottom: solid thin #ccc !important;
  border-right: solid thin #ccc !important;
  border-left: solid thin #ccc !important;
}
.input-label {
  width: 30%;
  border-right: solid thin #ccc !important;
  background: rgba(250, 230, 230) !important;
  padding: 8px !important;
}
.input-modal {
  width: calc(100% - 30%);
  height: 40px;
  color: #222 !important;
  font-size: 16px !important;
  background: #f8f8f8 !important;
  padding: 8px !important;
  border-radius: 0;
  border: none;
  box-shadow: none;
}

.table-box {
  width: 100%;
}
.table-box-header {
  border: solid thin #ccc !important;
  background: rgb(250, 230, 230) !important;
  color: #222;
  padding: 8px !important;
}
.input-table {
  height: 40px;
  color: #222 !important;
  font-size: 16px;
  background: #f8f8f8 !important;
  padding: 8px !important;
  border-radius: 0;
  box-shadow: none !important;
}
.container-birth{
  display: flex
}

.right-enter-active, .right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.right-enter, .right-leave-to {
  transform: translateX(100vw) translateX(0px);
}
.select-footer {
  position: fixed;
  bottom: 0;
  left: 200px;
  width: calc(100vw - 200px);
  height: 160px;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: white;
  transition: 0.5s;
}
.message-box {
  margin-left: 20px;
  height: 130px;
  width: calc(100% - 160px);
  border: solid 3px white;
  border-radius: 15px;
  border-top-left-radius: 0px;
  text-align: left;
  padding: 10px 20px;
}
.button-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 4px 0;
  overflow: unset;
}
.button-wrapper > div {
  border: none;
  margin-left: 4px;
}
/deep/ .nextApproach-table{
  width: 128px;
  height: 24px;
  margin: 0 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/deep/ .nextApproach-select{
  width: 128px;
  height: 24px;
  margin: 0 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.tooltip{
  position : relative;
  cursor   : pointer;
  display  : inline-block;
}
.tooltip-balloon {
  display       : none;
  position      : absolute;
  color         : #fff;
  background    : #363636;
  padding       : 8px;
  font-size     : 14px;
  border-radius : 5px;
  width         : 100px;
  z-index       : 30;
}
.tooltip-balloon:before {
  content    : "";
  position   : absolute;
  top        : -20px;
  left       : 5px;
  border     : 15px solid transparent;
  border-top : 15px solid #363636;
  transform  : rotateZ(180deg);
}
.tooltip:hover .tooltip-balloon{
  display : inline-block;
  top     : 34px;
  left    : 0px;
}
.approach {
  display: flex;
  align-items: center;
  width: 300px;
}
.-url {
  display: block;
  text-align: left;
  width: 200px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.tag-box {
  width: 200px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/DirectTalk/ScoutTableView.vue